import { render, staticRenderFns } from "./config.vue?vue&type=template&id=8c3ff40e"
import script from "./config.js?vue&type=script&lang=js&external"
export * from "./config.js?vue&type=script&lang=js&external"
import style0 from "./config.vue?vue&type=style&index=0&id=8c3ff40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports